import type { StatusValue } from "@shared/types";
import { cn } from "@/lib/utils";

const COLOR_BY_STATUS: Record<string, string> = {
  "0": "bg-status-down",
  "1": "bg-status-up",
  "2": "bg-status-pending",
  "3": "bg-status-maintenance",
};

export function StatusDot({
  status,
  paused = false,
  pulse = false,
  className,
}: {
  status: StatusValue | null;
  /** overrides status rendering with the paused color */
  paused?: boolean;
  /** subtle ping animation (use for currently-up monitors) */
  pulse?: boolean;
  className?: string;
}) {
  const color = paused
    ? "bg-status-paused"
    : (status != null && COLOR_BY_STATUS[String(status)]) || "bg-muted-foreground/40";
  return (
    <span className={cn("relative inline-flex size-2.5 shrink-0", className)}>
      {pulse && !paused && status === 1 && (
        <span className={cn("absolute inline-flex h-full w-full animate-ping rounded-full opacity-40", color)} />
      )}
      <span className={cn("relative inline-flex size-full rounded-full", color)} />
    </span>
  );
}
